import { render } from "./FilesSection.vue?vue&type=template&id=64b03ed3"
import script from "./FilesSection.vue?vue&type=script&lang=js"
export * from "./FilesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__